import * as React from 'react';

import { PropertyLocationViewModel } from 'models';

interface StreetAddressProps {
  propertyLocationInfo: PropertyLocationViewModel;
}

export const LocationStreetAddress: React.FunctionComponent<StreetAddressProps> = ({ propertyLocationInfo }) => (
  <div className="uitk-cell all-cell-1-1 all-x-padding-three">
    <h4 className="uitk-type-heading-500">{propertyLocationInfo.subtitleAddress}</h4>
    <dl className="uitk-grid all-cell-1-1 all-t-margin-two">
      {propertyLocationInfo.state && <dt className="uitk-cell">{propertyLocationInfo.state}</dt>}
      {propertyLocationInfo.city && <dt className="uitk-cell">{propertyLocationInfo.city}</dt>}
      {propertyLocationInfo.streetAddress && <dt className="uitk-cell">{propertyLocationInfo.streetAddress}</dt>}
      <dd />
    </dl>
  </div>
);

LocationStreetAddress.displayName = 'PropertyLocationStreetAddress';
